import { fetch } from 'app/utils/data'
import { default as deserialize } from 'app/utils/deserialize'

export default {
  namespaced: true,

  state: {
    list: []
  },

  getters: {
    currentPlanLimits: (state) => state.list
  },

  mutations: {
    setPlanLimits(state, newPlans) {
      state.list = newPlans
    }
  },

  actions: {
    async fetchPlanLimits({ commit }) {
      const response = await fetch({ url: '/api/admin/plan-limits' })
      const plans = await deserialize(response.data)

      commit('setPlanLimits', plans)
    }
  }
}
